// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__3TXvr","range":"MonthRangeSwitch_range__PEmdO","disabled":"MonthRangeSwitch_disabled__2IkZD"};